module.exports = __webpack_public_path__ + "img/helal-ahmar-iran.07a8d48.svg";